import { Typography, Box, styled } from "@mui/material";

const SchoolInfoContainer = styled(Box)({
  display: "flex",
  marginTop: "auto",
  marginBottom: "auto",
  alignItems: "center",
  gap: "10px",
});

const SchoolName = styled(Typography)({
  fontWeight: "bold",
  color: "#1A1A18",
});

export { SchoolInfoContainer, SchoolName };
